import React from 'react';
import { StyleSheet, View } from 'react-native';
import { MarkdownView } from 'react-native-markdown-view';
import { COLORS } from '@bcm/constants';
import { useSelector } from 'react-redux';

import privacyPolicy from './privacyPolicy';

const Privacy = () => {

	const isLandscape = useSelector( state => state.globals.isLandscape);

	const styles = StyleSheet.create({
		container: {
			marginHorizontal: isLandscape ? '10vw' : 0,
			padding: 20,
			backgroundColor: COLORS.light,
		},
	});

	return (
		<View style={styles.container}>
			<MarkdownView>{privacyPolicy.text}</MarkdownView>
		</View>
	);
};



export default Privacy;